<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <div v-if="ok">
          <validation-observer
            ref="observer"
            v-slot="{ invalid, handleSubmit }"
          >
            <b-form @submit.prevent="">
              <div class="form-card-wrapper">
                <b-card header-tag="header">
                  <template #header>
                    <b>Dati Identificativi</b>
                  </template>
                  <b-card-text>
                    <b-row>
                      <div class="form-group">
                        <base-input
                          :name="beForm[rep].display.label"
                          vid="display"
                          :label="beForm[rep].display.label"
                          v-model="form[rep].display"
                          placeholder="Inserisci un codice"
                          :rules="getRules('display')"
                          :disabled="true"
                        />
                      </div>
                      <div class="form-group">
                        <base-select
                          :name="beForm[rep].importer_id.label"
                          vid="importer_id"
                          :label="beForm[rep].importer_id.label"
                          v-model="form[rep].importer_id"
                          :options="beForm[rep].importer_id.options"
                          :rules="getRules('importer_id')"
                          @input="onInputImporterId"
                          :disabled="true"
                        />
                      </div>
                      <div class="form-group">
                        <base-input
                          :name="beForm[rep].title.label"
                          vid="title"
                          label="Descrizione Compagnia"
                          v-model="form[rep].title"
                          placeholder="Inserisci una descrizione"
                          :rules="getRules('title')"
                        />
                      </div>
                      <div style="grid-column: 1/2"  class="form-group">
                        <base-select
                          name="
                           Escludi ricalcolo ramo danni extra auto
                        "
                          vid="exclude_calc_extra_vehicle_branch"
                          label="
                          Escludi ricalcolo ramo danni extra auto
                        "
                          v-model="form.exclude_calc_extra_vehicle_branch"
                          :options="options"
                          :disabled="!form[rep].importer_id"
                          :rules="{ required: true }"
                        />
                      </div>
                      <div class="form-group">
                        <base-select
                          name="Escludi ricalcolo ramo vita"
                          vid="exclude_calc_life_branch"
                          label="Escludi ricalcolo ramo vita"
                          v-model="form.exclude_calc_life_branch"
                          :options="options"
                          :disabled="!form[rep].importer_id"
                          :rules="{ required: true }"
                        />
                      </div>
                      <div class="form-group">
                        <base-select
                          name="Escludi ricalcolo ramo auto"
                          vid="exclude_calc_vehicle_branch"
                          label="Escludi ricalcolo ramo auto"
                          v-model="form.exclude_calc_vehicle_branch"
                          :options="options"
                          :disabled="!form[rep].importer_id"
                          :rules="{ required: true }"
                        />
                      </div>
                    </b-row>
                  </b-card-text>
                </b-card>
              </div>
              <div class="form-card-wrapper">
                <b-card
                  header-tag="header"
                  v-if="canVerb('fattutto', 'config')"
                ><template #header>
                  <b>Flusso contabilità fiscale</b>
                </template>
                  <b-card-text>
                    <b-row>
                      <div class="form-group">
                        <base-checkbox
                          :name="beForm.fattutto.active.label"
                          vid="fattutto_active"
                          groupLabel=""
                          :label="beForm.fattutto.active.label"
                          v-model="form.fattutto.active"
                          :chk_val="true"
                          :unchk_val="false"
                        />
                      </div>
                      <div class="form-group">
                        <base-input
                          :name="beForm.fattutto.code.label"
                          vid="fattutto_code"
                          :label="beForm.fattutto.code.label"
                          v-model="form.fattutto.code"
                          placeholder="Inserisci un codice"
                          textcase="upper"
                          :rules="getCustomRules('fattutto_code')"
                        />
                      </div
                      >
                    </b-row>
                  </b-card-text>
                </b-card>
              </div>

              <div class="mt-2" v-show="customInputs[rep].length">
                <div class="form-card-wrapper">
                  <b-card header-tag="header">
                    <template #header>
                      <b>Attributi personalizzati</b>
                    </template>
                    <b-card-text>
                      <custom-inputs
                        :customInputs="customInputs[rep]"
                        v-model="form[rep]"
                        :beForm="beForm[rep]"
                        :beRules="beRules[rep]"
                      />
                    </b-card-text>
                  </b-card>
                </div>
              </div>
              <div class="form-actions form-actions--sticky">
                <div class="inner-wrapper">
                  <div>
      <span
        :title="`${
          invalid
            ? 'Compila correttamente i campi per poter salvare'
            : 'Invia il form'
        }`"
      >
        <b-button
          @click="handleSubmit(onSubmit)"
          type="button"
          :disabled="invalid"
          variant="lisaweb"
          size="sm"
          :title="`${
            invalid
              ? 'Compila correttamente i campi per poter salvare'
              : 'Invia il form'
          }`"
        >
          Salva
        </b-button>
      </span>
                  </div>
                  <div>
                    <b-button
                      @click="goBack()"
                      class="btn--transparent"
                      type="button"
                      title="Torna alla pagina precedente"
                    >
                      <b-icon-chevron-double-left
                        font-scale="0.9"
                      ></b-icon-chevron-double-left
                      >
                      Torna indietro
                    </b-button
                    >
                  </div>
                </div>
              </div>
            </b-form>
          </validation-observer>
        </div>
        <div v-else>
          {{ errorMessage }}
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import {RepositoryFactory} from "@/repositories/RepositoryFactory";
import CustomInputs from "@/components/form/CustomInputs";
import BaseCheckbox from "@/components/form/BaseCheckbox";
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import FormMixin from "@/mixins/FormMixin";
import ShortcutMixin from "@/mixins/ShortcutMixin";
import ShowMixin from "@/mixins/ShowMixin";
import {mapGetters} from "vuex";
import {setFormValues} from "@/utils/forms";
import {canVerb} from "@/utils/permissions";

export default {
  mixins: [FormMixin, ShortcutMixin, ShowMixin],
  data() {
    return {
      repository: "insurer",
      id: this.$route.params.id,
      item: this.$route.params.item,
      options: [
        {text: "Si", value: "Y"},
        {text: "No", value: "N"},
      ],
      details: {},
      form: {
        exclude_calc_extra_vehicle_branch: null,
        exclude_calc_life_branch: null,
        exclude_calc_vehicle_branch: null,
        insurer: {
          display: null,
          importer_id: null,
          title: null,
        },
        fattutto: {
          code: "",
          active: false,
        },
      },
    };
  },
  components: {
    CustomInputs,
    BaseCheckbox,
    BaseInput,
    BaseSelect,
  },
  methods: {
    canVerb,
    goBack() {
      if (this.returnUrl) {
        switch (this.returnUrl) {
          case "profile-companies-products-edit":
            this.$router.push({
              name: "companies_products.editreate",
            });
            break;
          default:
            console.log(
              "No returnUrl set matched! Fallback to default back behavior."
            );
            this.$router.back();
            break;
        }
      } else {
        this.$router.back();
      }
    },
    getCustomRules(field) {
      let rules = {};
      if (field === "fattutto_code") {
        if (this.form.fattutto.active) {
          rules["required"] = true;
        } else {
          delete rules["required"];
        }
      }
      return rules;
    },
    onSubmit() {
      this.isLoading = true;
      console.log(this.setPayload());
      this.update(this.repository, this.id)
        .then((response) => {
          this.addtoInsurer(
            response.data.data.id,
            "risk_type",
            this.setPayload()
          )
            .then(() => {
              // this.$store.dispatch("auth/insurers");
              // this.$showSnackbar({
              //   preset: "success",
              //   text: `Azione Completata: Compagnia Modificata`,
              // });
              // this.shortcut("module.PROF", null, "#Companies", "filterInsurer");
              /* SAVE HERE FATTUTTO CONFIG with a new API call */
              const Repo = RepositoryFactory.get("fattutto");
              const payload = {
                configurable_id: this.id,
                configurable_type: "insurer",
                code: this.form.fattutto.code,
                ledger_type: 3, // no ledger_type
                // note: "",
                active: this.form.fattutto.active,
              };
              (this?.details?.id
                  ? Repo.update_configuration(this.details.id, payload)
                  : Repo.store_configuration(payload)
              )
                .then(() => {
                  // this.$store.dispatch("auth/mandate_codes");
                  this.$store.dispatch("auth/insurers");
                  this.$showSnackbar({
                    preset: "success",
                    text: `Azione Completata: Compagnia Modificata`,
                  });
                  this.shortcut(
                    "module.PROF",
                    null,
                    "#Companies",
                    "filterInsurer"
                  );
                })
                .catch((error) => {
                  let errMsg = this.$getErrorMessage(error);
                  this.$showSnackbar({
                    preset: "error",
                    text: `${errMsg}`,
                  });
                  this.isLoading = false;
                  // .finally(() => {
                  //   this.isLoading = false;
                  // });
                });
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: `${errMsg}`,
              });
              this.isLoading = false;
            });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.isLoading = false;
        });
    },
    defaultBranchConfig() {
      const riskTypesPivot = this.item.risk_types;
      this.form.exclude_calc_vehicle_branch = riskTypesPivot.find(
        (risk) => risk.code === "A"
      )?.pivot.is_excluded.value;
      this.form.exclude_calc_life_branch = riskTypesPivot.find(
        (risk) => risk.code === "V"
      )?.pivot.is_excluded.value;
      this.form.exclude_calc_extra_vehicle_branch = riskTypesPivot.find(
        (risk) => risk.code === "D"
      )?.pivot.is_excluded.value;
    },
    onInputImporterId(val) {
      if (!val) {
        this.defaultBranchConfig();
      }
    },
    addtoInsurer(insurer_id, relation, payload) {
      const Repo = RepositoryFactory.get("insurer");
      return Repo.pivot_update(insurer_id, relation, payload);
    },
    setPayload() {
      return {
        risk_type: {
          [this.getRisks().find((risk) => risk.code === "A").value]: {
            is_excluded: this.form.exclude_calc_vehicle_branch,
          },
          [this.getRisks().find((risk) => risk.code === "V").value]: {
            is_excluded: this.form.exclude_calc_life_branch,
          },
          [this.getRisks().find((risk) => risk.code === "D").value]: {
            is_excluded: this.form.exclude_calc_extra_vehicle_branch,
          },
        },
      };
    },
    ...mapGetters("auth", {
      getRisks: "risks",
    }),
  },
  created() {
    this.isLoading = true;
    this.fetchShowForm(this.repository, this.id)
      .then((response) => {
        console.log("response", response);
        const data = response.data.data?.fattutto_configuration?.[0] ?? {};
        this.details = data;
        this.fetchEditForm(this.repository, this.id).then(() => {
          this.beForm.fattutto = {};
          this.beForm["fattutto"].active = {
            label: `Compagnia attiva all'esportazione per contabilità fiscale`,
            type: "select",
            value: this.form.fattutto.active,
          };
          this.beForm["fattutto"].code = {
            label: `Codice Compagnia per flusso esportazione contabilità fiscale`,
            type: "text",
            value: this.form.fattutto.code,
          };
          if (Object.entries(this.details).length) {
            this.beForm["fattutto"].active.value = Boolean(this.details.active);
            this.beForm["fattutto"].code.value = this.details.code;
          }
          this.form["fattutto"] = setFormValues(
            ["active", "code"],
            this.beForm["fattutto"]
          );
          this.defaultBranchConfig();
          this.isLoading = false;
          if (this.form[this.rep].importer_id == null) {
            this.form.exclude_calc_vehicle_branch = "N";
            this.form.exclude_calc_life_branch = "N";
            this.form.exclude_calc_extra_vehicle_branch = "N";
          }
        });
      })
      .catch((error) => {
        this.form = {};
        console.error(error);
        this.isLoading = false;
      });
  },
  computed: {
    rep() {
      return this.repository;
    },
  },
};
</script>
